module.exports = __webpack_public_path__ + "static/media/pics.da1a3d36.png";